import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import TextField, {
  TextFieldLabel,
  TextFieldInput,
  TextFieldTextArea,
  TextFieldWrapper,
  TextFieldCounter,
  TextFieldSlot,
  TextFieldMessage
} from '@lsq/nextgen/v2/text-field';
import './index.css';

export default function CustomInput({
  label,
  isMandatory = false,
  placeholder = '',
  control,
  errors,
  fieldName = '',
  className = '',
  RightIcon,
  pattern,
  patternValidate,
  errorMessage,
  containerStyle,
  isTextArea = false,
  showcounter = true,
  size,
  ...props
}) {
  return (
    <div className="field" style={{ marginBottom: `var(--ng-gp-0)`, ...containerStyle }}>
      <Controller
        name={fieldName}
        control={control}
        rules={{
          required:
            isMandatory && (errorMessage ? errorMessage : 'This field cannot be left blank'),
          pattern: pattern,
          validate: {
            notBlank: (value) => {
              if (isMandatory && typeof value === 'string' && value?.trim()?.length === 0) {
                return errorMessage || 'This field cannot be left blank';
              }
              if (isMandatory && typeof value === 'number' && value?.toString().length === 0) {
                return errorMessage || 'This field cannot be left blank';
              }
              return true;
            },
            ...(patternValidate ? { pattern: patternValidate } : {})
          }
        }}
        render={({ field, fieldState }) => (
          <TextField
            size={size}
            name={field.name}
            value={field.value ?? ''}
            onChange={(e) => field.onChange(e.target.value)}
            colorSchema={fieldState.error ? 'red' : 'blue'}
            maxLength={props.maxLength}
            className={className}>
            <TextFieldLabel showAsterisk={isMandatory}>{label}</TextFieldLabel>
            {isTextArea ? (
              <TextFieldTextArea placeholder={placeholder} {...props} />
            ) : (
              <TextFieldWrapper>
                <TextFieldInput placeholder={placeholder} onBlur={field.onBlur} {...props} />
                {RightIcon && (
                  <TextFieldSlot position="end">
                    <RightIcon />
                  </TextFieldSlot>
                )}
              </TextFieldWrapper>
            )}
            {errors[fieldName] && <TextFieldMessage>{errors[fieldName].message}</TextFieldMessage>}
            {props.maxLength && showcounter && <div className='ml-auto'><TextFieldCounter style={{textAlign:"right"}}  /></div>}
          </TextField>
        )}
      />
    </div>
  );
}

CustomInput.propTypes = {
  label: PropTypes.string,
  isMandatory: PropTypes.bool,
  placeholder: PropTypes.string,
  control: PropTypes.object,
  fieldName: PropTypes.string,
  RightIcon: PropTypes.object,
  errors: PropTypes.object,
  className: PropTypes.string,
  pattern: PropTypes.object,
  patternValidate: PropTypes.func,
  maxLength: PropTypes.number,
  errorMessage: PropTypes.string,
  containerStyle: PropTypes.object,
  isTextArea: PropTypes.bool
};
